import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import { AccountIcon } from 'mdi-react';
import classNames from 'classnames';
import _ from 'lodash';

import ExpandingSection from './ExpandingSection';
import NvpDisplay from './NvpDisplay';
import friendlyNames, { type FriendlyOrdered } from './friendlyNames';
import { dbsParseDodDn } from './pkiUtils';

const FRIENDLY_NAMES: FriendlyOrdered = [
  { SUBJECT_DN: 'Signer Name:' },
  { SIGNING_TIME: 'Sign Date (GMT):' },
  //{ SIGNING_TIME_GMT: "Sign Date in GMT:" },
  { ISSUER_DN: 'Issuing CA:' },
  { SERIAL_NUM: 'Serial #:' },
  { VALID_FROM: 'Issue Date (GMT):' },
  //{ VALID_FROM_GMT: "Issue Date in GMT:" },
  { VALID_TO: 'Expire Date (GMT):' },
  //{ VALID_TO_GMT: "Expire Date in GMT:" },
  { KEY_USAGE: 'Allowed Key Usage:' }
];

type Props = {
  classes: any,
  className?: string,
  signerInfo?: Object | null,
  label?: string,
  labelProps?: Object,
  title?: string | null,
  titleProps?: Object,
  iconProps?: Object,
  nvpDisplayProps?: Object,
  expanded?: boolean,
  onExpand?: () => void
};

const SignerInfo = ({
  classes,
  className,
  label = 'Signer Info:',
  labelProps = {},
  iconProps = {},
  nvpDisplayProps = {},
  signerInfo,
  title,
  ...otherProps
}: Props) => {
  const icon = <AccountIcon className={classes.colorPrimary} {...iconProps} />;

  const onlyFriendlyNames = true;
  const nvpData = friendlyNames(FRIENDLY_NAMES, onlyFriendlyNames).applyToArray(
    //$FlowFixMe
    friendlyNames.toArray(signerInfo)
  );

  let _signerTitle = title;
  if (_.isEmpty(_signerTitle) && signerInfo && _.has(signerInfo, 'SUBJECT_DN')) {
    const dn = dbsParseDodDn(signerInfo['SUBJECT_DN']);
    const cn = dn ? dn['cn']['cn'] : '<unknown>';
    _signerTitle = 'Signed By ' + cn;
  }

  return (
    <div className={classNames(classes.root, className)}>
      <ExpandingSection
        label={label}
        icon={icon}
        expandButton={!_.isEmpty(nvpData)}
        title={_signerTitle}
        {...otherProps}
      >
        <NvpDisplay
          className={classes.nvpDisplay}
          nvpData={nvpData}
          keyProps={labelProps}
          dividers
          dividerBefore
          dividerAfter
          {...nvpDisplayProps}
        />
      </ExpandingSection>
    </div>
  );
};

const styles = ({ spacing: { unit: spacing }, palette: { primary: primaryColorInfo } }) => ({
  root: {},
  colorPrimary: {
    color: primaryColorInfo.main
  },
  nvpDisplay: {
    marginLeft: spacing * 4
  }
});

export default withStyles(styles)(SignerInfo);
